module.exports = __webpack_public_path__ + "static/media/bomfrios.82627165.webp";